import {useQuery} from '@tanstack/react-query'
import {B2BMetricsRepository} from '../repositories/B2BMetricsRepository.ts'
import {AuthenticationRepository} from '../repositories/AuthenticationRepository.ts'

const b2bMetricsRepository = new B2BMetricsRepository(new AuthenticationRepository())

export function useB2BReferralStats(agencyId: string, year?: number, isSelfService = false) {
    const query = useQuery({
        queryKey: ['b2b-referral-stats', agencyId, year],
        queryFn: () => b2bMetricsRepository.getB2BReferralStats(agencyId, year, isSelfService),
        enabled: !!agencyId,
    })

    return {
        stats: query.data,
        isLoadingStats: query.isLoading,
        statsError: query.error,
    }
}
